/* eslint-disable max-len */
import { template_translation } from '../lang/TemplateTranslation';
const t = template_translation;

/** 14. 飛び乗れるキューブ */
export const template14 = {
  title: t.to('飛び乗れるキューブ', 'title14'),
  desc: t.to(
    `無数に浮かんだキューブに注視点カーソルを合わせると、キューブに飛び乗ることができます。`,
    'desc14'
  ),
  img: '../public/template/14.png',
  xml: `<xml xmlns="http://www.w3.org/1999/xhtml">
  <variables>
  </variables>
  <block type="a-scene-start" x="130" y="130">
    <field name="is_init">off</field>
    <field name="hasController">on</field>
    <statement name="IN">
      <block type="a-camera_v2.1">
        <field name="position-x">0</field>
        <field name="position-y">1.7</field>
        <field name="position-z">4</field>
        <field name="avator_type">teat_Avatar_ver2.glb</field>
        <field name="click_type">cursor</field>
        <next>
          <block type="logic_range-loop_v2">
            <field name="COUNTER_VAR">x</field>
            <field name="RANGE_MIN">0</field>
            <field name="RANGE_MAX">100</field>
            <statement name="IN">
              <block type="cube_v2">
                <field name="id">block1</field>
                <field name="position-x">0</field>
                <field name="position-y">0</field>
                <field name="position-z">0</field>
                <value name="COLOUR">
                  <shadow type="color_value_v2">
                    <field name="COLOUR">#266e24</field>
                  </shadow>
                </value>
                <value name="ATTR">
                  <block type="random-position">
                    <value name="ATTR">
                      <block type="random-color">
                        <value name="ATTR">
                          <block type="checkpoint">
                            <field name="speed">1</field>
                            <field name="offset_y">1.7</field>
                          </block>
                        </value>
                      </block>
                    </value>
                  </block>
                </value>
              </block>
            </statement>
          </block>
        </next>
      </block>
    </statement>
  </block>
</xml>

`,
};
